"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeCheck = void 0;
var lodash_1 = __importDefault(require("lodash"));
var TypeCheck = /** @class */ (function () {
    function TypeCheck() {
    }
    // Array 검사
    TypeCheck.isValidArray = function (id) {
        if (!this.isValidObject(id)) {
            return false;
        }
        if (!lodash_1.default.isArray(id)) {
            return false;
        }
        if ((id === null || id === void 0 ? void 0 : id.length) === 0) {
            return false;
        }
        return true;
    };
    // Object 검사
    TypeCheck.isValidObject = function (id) {
        if (lodash_1.default.isNull(id)) {
            return false;
        }
        if (lodash_1.default.isUndefined(id)) {
            return false;
        }
        // if (Object.keys(id).length === 0) return false;
        return true;
    };
    // 문자열 검사
    TypeCheck.isValidString = function (id) {
        if (!this.isValidObject(id)) {
            return false;
        }
        if (id === '') {
            return false;
        }
        return true;
    };
    // 숫자 검사
    TypeCheck.isValidNumber = function (id) {
        if (lodash_1.default.isNaN(id)) {
            return false;
        }
        if (id === this.INVALID_NUM || id === this.NUMBER_NOT_SET || id < 0) {
            return false;
        }
        return true;
    };
    TypeCheck.itemsByPath = function (origin, args) {
        // origin 유효성 검증
        if (this.isValidObject(origin) === false) {
            return null;
        }
        // argument 분리
        var items = args.split('.');
        // argument 사이즈 검증
        if (items.length > 0) {
            // hasOwnProperty
            if (!lodash_1.default.has(origin, items[0])) {
                return null;
            }
            // set value
            var target = origin[items[0]];
            // param 검증
            if (lodash_1.default.isUndefined(target)) {
                return null;
            }
            if (lodash_1.default.isNull(target)) {
                return null;
            }
            // 배열일 경우 처리
            if (lodash_1.default.isArray(target)) {
                if (this.isValidArray(target)) {
                    return target;
                }
                return [];
            }
            // depth 검증
            if (items.length === 1) {
                return target;
            }
            items.shift();
            return this.itemsByPath(target, items.toString().replace(',', '.'));
        }
        return args;
    };
    // 기본 설정값 문자열 오류
    TypeCheck.INVALID_STRING = 'invalidValue';
    // 기본 설정값 숫자 오류
    TypeCheck.INVALID_NUM = -1;
    // 설정된 값 없음
    TypeCheck.NUMBER_NOT_SET = 0;
    return TypeCheck;
}());
exports.TypeCheck = TypeCheck;
